import {
    Component, ElementRef, HostListener, Input, QueryList, ViewChild, ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { Md2Datepicker } from 'md2';

@Component({
    selector: 'ig-drop-down-item-group',
    templateUrl: './drop.down.item.group.component.html',
    styleUrls: ['./drop.down.item.group.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DropDownItemGroupComponent {
    public isHovering: boolean;
    @Input() public text: string;
    @Input() public isDisable: boolean;
    @ViewChild('subItems') public subItems: ElementRef;

    // @ViewChildren(Md2Datepicker) public datePickers: QueryList<Md2Datepicker>;

    constructor(private elementRef: ElementRef) {
    }

    @HostListener('mouseover')
    public onMouseOver() {
        this.isHovering = true;
        let rect = this.elementRef.nativeElement.getBoundingClientRect();
        let subItemsContainer = this.subItems.nativeElement;
        subItemsContainer.style.left = `${rect.width}px`;
        subItemsContainer.style.top = `0px`;
    }

    @HostListener('mouseout')
    public onMouseOut() {
        if (event && ((event.target as any).className == 'md2-datepicker-input'
                || (event.target as any).className == 'md2-calendar-body-cell-content')) {
            return;
        }

        this.isHovering = false;
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/item.group/drop.down.item.group.component.ts